import { AuthSlice, SliceCreator } from '../store.types';
import { createSliceState } from '../serverState';
import { createAuthEndpoints } from '../../services/AuthService';

const createAuthSlice: SliceCreator<AuthSlice> = (set, get) => ({
  ...createSliceState(() => createAuthEndpoints(set, get)),
});

export default createAuthSlice;
